import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import {
  AppleFill,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  CalendarFill,
  CalendarOutline,
  CheckCircleOutline,
  ClockCircleOutline,
  CloseOutline,
  DeleteOutline,
  DownloadOutline,
  EditFill,
  EditOutline,
  ExportOutline,
  FileOutline,
  FileTextOutline,
  GlobalOutline,
  GoogleOutline,
  LeftOutline,
  MoreOutline,
  PhoneFill,
  PlusOutline,
  SyncOutline,
  RightOutline,
  SearchOutline,
  ShoppingCartOutline,
  StarFill,
  TagsOutline,
  UploadOutline,
} from '@ant-design/icons-angular/icons';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CUSTOM_ICONS } from './custom-icons';

const icons = [
  AppleFill,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  CalendarFill,
  CalendarOutline,
  CheckCircleOutline,
  ClockCircleOutline,
  CloseOutline,
  DeleteOutline,
  DownloadOutline,
  EditFill,
  EditOutline,
  ExportOutline,
  FileOutline,
  FileTextOutline,
  GlobalOutline,
  GoogleOutline,
  LeftOutline,
  MoreOutline,
  PhoneFill,
  PlusOutline,
  SyncOutline,
  RightOutline,
  SearchOutline,
  ShoppingCartOutline,
  StarFill,
  TagsOutline,
  UploadOutline,
  ...CUSTOM_ICONS,
];

export const ALL_ICONS = icons;

export function provideNzIcons(): EnvironmentProviders {
  return importProvidersFrom(NzIconModule.forRoot(icons));
}
